import { Box, useTheme } from "@mui/material"
import React, { useContext, useEffect, useState } from "react"
import { userService } from "../../services/auth";
import NewButton from "../../components/NewButton";
import { UserTypeContext } from "../../context/userStatus";
import { setUserObject } from "../../store/actions/userTypeAction";
import { weekDays } from "../../utils/staticDataJson";
import CommonTypo from "../../components/CommonTypo";

const capitalise = (name: string) => {
    const trimmed = name.toLowerCase().slice(0, 3)
    return trimmed.slice(0, 1).toUpperCase() + trimmed.slice(1, trimmed.length).toLowerCase()
}

const days = [...weekDays].map(it => {
    return {
        label: capitalise(it.day),
        value: it.day
    }
})
const TrackingSchedule = ({
    setShowSnakbar,
    setSnakbarMsg,
    setMsgType
}) => {
    const [selectedDays, setSelectedDays] = useState([])
    let userValues = JSON.parse(localStorage.getItem("userValues"));
    const { state: outcomeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    const [buttonLoading, setButtonLoading] = useState(false)
    const isDarkMode = useTheme().palette.mode === "dark" || outcomeState.isDarkMode
    const handleChangeHolidayMode = () => {
        const token = localStorage.getItem("userDetails")
        setButtonLoading(true)
        userService.updateTrackingSchedule({
            "userWorkingDays": selectedDays
        }, token).then((data) => {
            const userId = {
                uid: outcomeState?.userId ? outcomeState?.userId : userValues?.uid,
            };
            userService
                .getUserById(userId)
                .then((data: any) => {
                    console.log("data", data);
                    
                    userTypeDispatch(
                        setUserObject({
                            ...data?.data,
                            showGoal: data?.showGoal,
                            userSubscriptionStatus: data.userSubscriptionStatus,
                            userAccountStatus: data?.userAccountStatus,
                            celebrationData: data?.celebrationData,
                            formatHolidayEndDate: data?.formatHolidayEndDate,
                            formatHolidayStartDate: data?.formatHolidayStartDate,
                            holidayMode: data?.holidayMode
                        })
                    );
                    localStorage.setItem("userValues", JSON.stringify(data?.data));
                    setButtonLoading(false)

                }).catch(() => {
                    setButtonLoading(false)
                })
        }).catch((err) => {
            setButtonLoading(false)

        })
    }

    useEffect(() => {
        if (outcomeState.userDetails && outcomeState.userDetails.userWorkingDays) {
            setSelectedDays(outcomeState.userDetails.userWorkingDays)
        } else {
           setSelectedDays([]) 
        }
    }, [outcomeState.userDetails])

    return <>
        <Box display={"flex"} alignItems={"flex-start"} flexDirection={"column"} gap={"24px"}>
            <Box display={"flex"} alignItems={"center"} gap={"0px"} width={"100%"} border={"1px solid var(--color-border)"} borderRadius={"12px"}>
                {days.map((it, index) => {
                    return <Box
                        key={it.value}
                        width={"calc(100% / 7)"}
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        padding={"18px 0"}
                        sx={{
                            borderRadius: !index ? "12px 0px 0px 12px" : index === (days.length - 1) ? "0px 12px 12px 0px" : 0,
                            background: selectedDays.includes(it.value) ? "var(--color-new-main)" : "transparent",
                            borderRight: index === (days.length - 1) ? "none" : "1px solid var(--color-border)",
                            cursor: "pointer"
                        }}
                        onClick={() => {
                            const previousState = [...selectedDays]
                            if (previousState.includes(it.value)) {
                                const newState = [...previousState].filter(ite => ite !== it.value)
                                setSelectedDays(newState)
                            } else {
                                previousState.push(it.value)
                                setSelectedDays(previousState)
                            }
                        }}
                    >
                        <CommonTypo fontWeight={selectedDays.includes(it.value) ? 600 : 400} color={selectedDays.includes(it.value) ? isDarkMode? "var(--white-background)" : "var(--color-text-primary)" :"var(--color-text-secondary)"} size={12}>{it.label}</CommonTypo>
                    </Box>
                })}
            </Box>
            <Box display={"flex"} alignItems={"center"} justifyContent={"flex-end"} width={"100%"} gap={"24px"}>
                <NewButton isLoadong={buttonLoading} buttonText={"Save"} borderRadius={"20px !important"} padding="16px" extraSx={{
                    background: "var(--color-new-main)",
                    border: "none",
                    width: "67px",
                    height: "40px",
                    marginBottom: "0px !important",
                    "&:hover": {
                        background: "var(--color-new-main)"
                    },
                    "&.MuiButton-outlined": {
                        border: `none`,
                    },
                    "&.MuiButton-contained": {
                        border: `none`,
                    },
                }} fontSize={`16px`} fontWeight={600} typographySx={{
                    color: "var(--color-text-primary)",
                    fontSize: "16px !important",
                    lineHeight: "16px !important",
                    fontWeight: `600 !important`,
                    letterSpacing: "2% important"
                }} onClick={() => {
                    handleChangeHolidayMode()
                }} /* onClick={outcomeState.restrictUser ? () => userTypeDispatch(setOpenSubscriptionModal(true)) : () => closeModal(true)} */ />
            </Box>
        </Box>
    </>
}

export default TrackingSchedule
